module.exports = "<h2>Default Arguments</h2><pre class=\"fragment\"><code class=\"lang-kotlin\">class Book(val name: String = \"Hitch Hiker's Guide\",\n           val author: String = \"D. Adams\")\n\nval myBook = Book(author = \"Adams, Douglas\")</code></pre>";


//////////////////
// WEBPACK FOOTER
// ./src/slides/04-syntax/03.pug
// module id = 325
// module chunks = 1